import { useSelector } from "react-redux";
import { RootState } from "../index";

export const getRegisterInfo = () =>
    useSelector((state: RootState) => state.registration);

export const isShowModalAuthSelector = (state: RootState) =>
    state.registration.modaAuthShow;
